import PersonIcon from "@mui/icons-material/Person";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";

export const NAVIGATION = [
    { segment: "/perfil", title: "Meu Perfil", icon: <PersonIcon /> },
    {
        segment: "/perfil/devolve",
        title: "Meu Cupom Devolve",
        icon: <CurrencyExchangeIcon />,
    },
];
